export const typeOption = [
  { label: '早班会', value: 1 },
  { label: '周例会', value: 2 },
  { label: '月度安全生产例会', value: 4 },
  { label: ' 其他', value: 3 }
]

export const typeMapping = {
  1: '早班会',
  2: '周例会',
  3: '其他',
  4: '月度安全生产例会'
}
